let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k6yQE")).then(() => parcelRequire('4Xmvj'));